import { ref } from 'vue';

// Lightweight, client-side favourites for VOD folders and videos.
// Persisted in localStorage and shared (module-level reactive ref) so every
// component that calls useFavorites() observes the same state.
const STORAGE_KEY = 'castr.vod.favorites';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch (e) {
    return new Set();
  }
}

const favorites = ref(load());

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...favorites.value]));
  } catch (e) { /* ignore quota / privacy mode */ }
}

export function useFavorites() {
  const isFavorite = (id) => !!id && favorites.value.has(id);

  const toggleFavorite = (id) => {
    if (!id) return;
    const next = new Set(favorites.value);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    favorites.value = next; // reassign so refs update
    persist();
  };

  return { favorites, isFavorite, toggleFavorite };
}
